module.exports = "/images/plan-pro-icon.svg?4f739fc77d51e9556a3f44bda3ce773e";